"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PINO_CUSTOM_CONTEXT_KEY = exports.PINO_LOGGER_DEFAULTS = void 0;
exports.PINO_LOGGER_DEFAULTS = {
    level: "info",
    prettyPrint: {
        colorize: true,
        translateTime: "SYS:standard",
        ignore: "pid,hostname",
    },
};
exports.PINO_CUSTOM_CONTEXT_KEY = "custom_context";
//# sourceMappingURL=constants.js.map